import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import selectn from "selectn";
import { Query } from "react-apollo";

import ErrorBoundary from "components/Library/ErrorBoundary";
import isPermalinkSupportedInAMP from "stream/utils/isPermalinkSupportedInAMP";
import PERMALINK_STREAM_HELMET_QUERY from "./PermalinkStreamHelmet.graphql";

export default function PermalinkStreamHelmet({ id }) {
  return (
    <ErrorBoundary>
      <Query query={PERMALINK_STREAM_HELMET_QUERY} variables={{ id }}>
        {({ loading, data }) => {
          if (loading) return null;

          const { content } = data;
          const ogImage =
            selectn("social_image.crops.lead.url", content) ||
            selectn("primary_image.crops.lead.url", content);

          // Stories converted from RebelMouse may not have primary tag
          const tags =
            content.primary_tag && content.primary_tag.name
              ? [content.primary_tag, ...content.tags]
              : content.tags;
          const concatenatedTags = tags.map(tag => tag.name).join(", ");

          return (
            <Helmet>
              <title>{content.seo_headline || content.headline} - Axios</title>
              <meta property="og:url" content={content.permalink} />
              <link rel="canonical" href={content.permalink} />
              {isPermalinkSupportedInAMP(content) && (
                <link rel="amphtml" href={content.amp_permalink} />
              )}
              <meta
                property="og:title"
                content={content.og_headline || content.headline}
              />
              {content.og_description && (
                <meta
                  property="og:description"
                  content={content.og_description}
                />
              )}
              {content.og_description && (
                <meta name="description" content={content.og_description} />
              )}
              {ogImage && <meta property="og:image" content={ogImage} />}
              {concatenatedTags && (
                <meta name="keywords" content={concatenatedTags} />
              )}
            </Helmet>
          );
        }}
      </Query>
    </ErrorBoundary>
  );
}

PermalinkStreamHelmet.propTypes = {
  id: PropTypes.string.isRequired,
};
